export const normalizePlatformName = (value) => {
    const normalized = String(value || '').trim().toLowerCase();
    if (['chatgpt_ads', 'chatgpt-ads', 'chatgpt ads'].includes(normalized)) return 'ChatGPT Ads';
    if (normalized === 'display') return 'Programmatic';
    if (normalized === 'linkedin' || normalized === 'linked in') return 'LinkedIn';
    if (normalized === 'tiktok' || normalized === 'tik tok') return 'TikTok';
    if (normalized === 'infillion') return 'Programmatic';
    return value || 'Platform';
};
